import { useCallback, useEffect, useState } from 'react'

interface UseExpandedRowsOptions {
  resetOn: React.DependencyList
}

interface UseExpandedRowsReturn {
  expandedRows: Set<number>
  toggleRow: (orderItemId: number) => void
}

export const useExpandedRows = ({ resetOn }: UseExpandedRowsOptions): UseExpandedRowsReturn => {
  const [expandedRows, setExpandedRows] = useState<Set<number>>(new Set())
  const toggleRow = useCallback((orderItemId: number) => {
    setExpandedRows(prev => {
      const next = new Set(prev)
      if (next.has(orderItemId)) {
        next.delete(orderItemId)
      } else {
        next.add(orderItemId)
      }
      return next
    })
  }, [])

  useEffect(() => {
    setExpandedRows(new Set())
  }, [...resetOn])

  return {
    expandedRows,
    toggleRow,
  }
}
